//文字コードはutf-8

/* グローバルナビ（SP/タブレット）
 * - ハンバーガーで .gnav オーバーレイを開閉
 * - ドロップダウンをタップアコーディオン化（SP幅）
 * - PC幅（≥1001）はCSSホバー表示が基本だが、ホバー不可のタッチ端末
 *   （iPad Pro等の大型タブレット・横向き含む）はタップで開閉する
========================================================*/
import { MEDIA_QUERIES } from '../utils/breakpoints.js';

export function initDrawer() {
    const toggle = document.getElementById('js-drawerToggle');
    const gnav = document.getElementById('js-gnav');
    if (!toggle || !gnav) return;

    const body = document.body;
    const spMq = window.matchMedia(MEDIA_QUERIES.sp_x_tablet);
    const hoverMq = window.matchMedia('(hover: hover) and (pointer: fine)'); // g.hover のCSS条件と同一
    const dropItems = gnav.querySelectorAll('.gnav__item--drop');
    const dropButtons = gnav.querySelectorAll('.gnav__link--drop');
    const dispatch = (open) => document.dispatchEvent(new CustomEvent('drawer:toggle', { detail: { open } }));

    const closeAllDrops = () => {
        dropItems.forEach((item) => item.classList.remove('isOpen'));
        dropButtons.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
    };

    const close = () => {
        toggle.classList.remove('isActive');
        gnav.classList.remove('isOpen');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'メニューを開く');
        body.classList.remove('scrollLock');
        dispatch(false);
    };

    const open = () => {
        toggle.classList.add('isActive');
        gnav.classList.add('isOpen');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-label', 'メニューを閉じる');
        body.classList.add('scrollLock');
        dispatch(true);
    };

    toggle.addEventListener('click', () => {
        gnav.classList.contains('isOpen') ? close() : open();
    });

    // メニュー内のリンクをタップしたら閉じる（ドロップ開閉は<button>なので対象外）
    gnav.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
        close();
        closeAllDrops();
    }));

    // ---- ドロップダウンの開閉 ----
    dropButtons.forEach((btn) => {
        const panel = btn.nextElementSibling; // .gnav__dropdown
        if (!panel) return;
        const item = btn.closest('.gnav__item--drop');

        // 実マウス（PC幅・ホバー可）でのクリックはフォーカスを与えない
        // （:focus-within でホバーと同じ表示が起き、マウスが離れても開いたままになるのを防ぐ）
        btn.addEventListener('mousedown', (e) => {
            if (!spMq.matches && hoverMq.matches) e.preventDefault();
        });

        btn.addEventListener('click', () => {
            if (spMq.matches) {
                // SP/タブレット（ハンバーガー時）: 高さアコーディオン
                const isOpen = btn.getAttribute('aria-expanded') === 'true';
                if (isOpen) {
                    panel.style.height = panel.scrollHeight + 'px';
                    requestAnimationFrame(() => { panel.style.height = '0px'; });
                    btn.setAttribute('aria-expanded', 'false');
                } else {
                    panel.style.height = panel.scrollHeight + 'px';
                    btn.setAttribute('aria-expanded', 'true');
                    panel.addEventListener('transitionend', function te() {
                        panel.style.height = 'auto';
                        panel.removeEventListener('transitionend', te);
                    });
                }
                return;
            }

            if (hoverMq.matches) return; // 実マウスのPCはホバー表示に任せる

            // PC幅だがホバー不可（タブレット実機。iPad Pro・横向き等）: タップで開閉
            const isOpen = item.classList.contains('isOpen');
            closeAllDrops();
            if (!isOpen) {
                item.classList.add('isOpen');
                btn.setAttribute('aria-expanded', 'true');
            }
        });
    });

    // タブレット実機（ホバー不可のPC幅）: ドロップダウンの外をタップしたら閉じる
    document.addEventListener('click', (e) => {
        if (spMq.matches || hoverMq.matches) return;
        if (!e.target.closest('.gnav__item--drop')) closeAllDrops();
    });

    // 幅がSP⇄PCの境界をまたいだらメニュー・アコーディオン・ドロップダウンをリセット
    const onChange = () => {
        close();
        closeAllDrops();
        dropButtons.forEach((btn) => {
            const panel = btn.nextElementSibling;
            if (panel) panel.style.height = '';
        });
    };
    if (spMq.addEventListener) spMq.addEventListener('change', onChange);
    else spMq.addListener(onChange);
}
